"use strict";

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  /**
   * @ngdoc object
   * @name login.controller:LoginCtrl
   *
   * @description
   *
   */

  LoginCtrl.$inject = ["$rootScope", "$scope", "AuthService", "UsersService"];
  angular.module("login").controller("LoginCtrl", LoginCtrl);

  function LoginCtrl($rootScope, $scope, AuthService, UsersService) {
    var _this = this;

    var vm = this;
    vm.ctrlName = "LoginCtrl";

    $("#loading").remove();

    vm.load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    vm.load();

    vm.checkYourEmail = false;
    vm.isLoginPending = false;

    vm.login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!vm.isLoginPending) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (!(!vm.email || !vm.with2FA && !vm.password || vm.with2FA && !vm.code)) {
                _context2.next = 5;
                break;
              }

              Notiflix.Notify.failure("Veuillez renseigner tous les champs.");
              return _context2.abrupt("return");

            case 5:

              vm.isLoginPending = true;
              Notiflix.Loading.standard("Connexion en cours...");

              _context2.prev = 7;
              _context2.next = 10;
              return AuthService.login(vm.email, vm.password, vm.code);

            case 10:
              _context2.next = 12;
              return AuthService.whoami();

            case 12:
              _context2.next = 27;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](7);

              console.log("login err", _context2.t0);

              if (!(_context2.t0 && _context2.t0.message === "2FA requis")) {
                _context2.next = 22;
                break;
              }

              vm.with2FA = true;
              vm.code = null;
              $scope.$evalAsync();
              return _context2.abrupt("return");

            case 22:

              $rootScope.$user = null;

              $rootScope.$bus.publish({
                channel: "login",
                topic: "failed",
                data: {}
              });

              message = _context2.t0 && typeof _context2.t0.message === "string" && _context2.t0.message ? _context2.t0.message : "Identification impossible : réessayez ou contactez le support.";
              _context2.next = 27;
              return swal("Identification impossible", message, "error");

            case 27:
              _context2.prev = 27;

              Notiflix.Loading.remove();
              vm.isLoginPending = false;
              $scope.$evalAsync();
              return _context2.finish(27);

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[7, 14, 27, 32]]);
    }));

    vm.getLink = function () {
      Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

      try {
        UsersService.customGet("sendLink/" + vm.email).then(function (response) {
          if (response.success === true) {
            Notiflix.Notify.success("L'envoi de l'email a réussi");
            vm.checkYourEmail = true;
          }
          Notiflix.Loading.remove();
        }).catch(function (error) {
          Notiflix.Notify.failure("L'envoi de l'email a échoué ou l'utilisateur n'existe pas");
          Notiflix.Loading.remove();
        });
      } catch (error) {
        Notiflix.Notify.failure("L'envoi de l'email a échoué ou l'utilisateur n'existe pas");
        Notiflix.Loading.remove();
      }
    };
  }
})();